module.exports = __webpack_public_path__ + "jizvy_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/jizvy_1_before.jpg
// module id = 950
// module chunks = 0